var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card-content",
    [
      _c(
        "w-row",
        [
          _c("w-col", { attrs: { xs: "12" } }, [
            _c("div", { staticClass: "notice" }, [
              _vm._v("Kopie wordt gemaakt. Sluit dit venster NIET!"),
            ]),
          ]),
          _c(
            "w-col",
            { attrs: { xs: "12" } },
            [_c("w-progress-circular", { attrs: { large: "" } })],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }